/* ---------------------------------------------------------------------------
   Central config. The API base URL is the existing sgadj REST API (careers,
   admissions and now the CMS content/admin routes all live under it). Override
   with REACT_APP_API_BASE_URL in .env when pointing at a different stage.
--------------------------------------------------------------------------- */
export const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  "https://m9luhuc58h.execute-api.ap-south-1.amazonaws.com/prod";

// Google OAuth client id for the admin login. Empty until you create one; the
// admin login screen shows a setup notice while it is unset.
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
